/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Describes representation of a Type-0 Stacks 2.0 transaction. https://github.com/blockstack/stacks-blockchain/blob/master/sip/sip-005-blocks-and-transactions.md#type-0-transferring-an-asset
 * @export
 * @interface ReadOnlyFunctionArgs
 */
export interface ReadOnlyFunctionArgs {
    /**
     * The simulated tx-sender
     * @type {string}
     * @memberof ReadOnlyFunctionArgs
     */
    sender: string;
    /**
     * An array of hex serialized Clarity values
     * @type {Array<string>}
     * @memberof ReadOnlyFunctionArgs
     */
    arguments: Array<string>;
}

export function ReadOnlyFunctionArgsFromJSON(json: any): ReadOnlyFunctionArgs {
    return ReadOnlyFunctionArgsFromJSONTyped(json, false);
}

export function ReadOnlyFunctionArgsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyFunctionArgs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sender': json['sender'],
        'arguments': json['arguments'],
    };
}

export function ReadOnlyFunctionArgsToJSON(value?: ReadOnlyFunctionArgs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sender': value.sender,
        'arguments': value.arguments,
    };
}

